// extracted by mini-css-extract-plugin
module.exports = {"container":"ModelViewer_container__OI2iX","gradient":"ModelViewer_gradient__Vhtuo"};